import { Constants } from 'app/utility/constants';
import { ReportParamSetType } from 'app/utility/enums';
import { ReportParamSetModel } from './reportSpec.model';

export class ReportParameterModel
{
    name: string;
    value: any;
}

export class ReportDynamicParametersModel
{
    reportSpecId: string;
    parameters: ReportParamSetModel[];
}

export class ManagerStockListModel
{
    totalVehicles: number;
    totalVehicleCost: string;
    totalRetailPrice: string;
    totalGrossProfit: string;
    totalNetProfit: string;
    totalNetMargin: string;
    avgGrossProfit: string;
    avgNetProfit: string;
    avgNetMargin: string;
    graphDataVehicleStatus: Array<any | any>;
    graphDataDaysOnYard: Array<any | any>;
}

export class SalePersonStockListModel
{
    totalRowCount: number;
    graphData: Array<any | any>;
}

export class ManagerSalesReportModel
{
    totalVehicles: number;
    totalSalesCount: number;
    totalVehicleCost: string;
    totalVehicleAmount: string;
    avgCostSold: string;
    totalFinanceProfit: string;
    avgFinanceProfit: string;
    totalSaleAmount: string;
    avgSale: string;
    totalGrossProfit: string;
    avgGrossProfit: string;
    totalNetProfit: string;
    totalNetProfitGstAmount: string;
    avgNetProfit: string;
    profitVehicleTotal: string;
    profitExtraTotal: string;
    totalExtrasAmount: string;
    totalInsuranceAmount: string;
    netTradesAmount: string;
    profitPerUnit: string;
    profitPerUnitExtras: string;
    profitPerUnitFinance: string;
    profitPerUnitTotal: string;
    profitPerUnitGstAmount: string;
    graphData: Array<any | any>;


    totalNetProfitRed: boolean;
    profitPerUnitRed: boolean;
}

export class ReportSearchParamsModel
{
    dealershipId: string = Constants.EmptyGuid;
    saleType: string = "All";
    lastMonth: string = "false";
    excludeInProgressSales: string = "false";
	dateRange: string = "LastMonth";
}

export class StocktakeReportModel
{
    totalVehicles: number;
    graphDataVehicleStatus: Array<any | any>;
    graphDataVehicleStatusSummary: Array<any | any>;
}

export class MoneyOutstandingReportModel
{
    completed: string;
	inProgress: string;
	total: string;
}
